/**
 * Shared element icon using the same gameboard-tokens SVGs as the in-game
 * player art. Lives here (not in medievalTheme) because deckStats is the
 * only consumer right now. Promote to a shared location if another
 * surface starts rendering element tokens.
 */
import { t } from '../../localization/t';

const TOKEN_ASSET_BASE = '/game-assets/gameboard-tokens';

const TOKEN_BY_ELEMENT = {
  Water: `${TOKEN_ASSET_BASE}/water-token.svg`,
  Earth: `${TOKEN_ASSET_BASE}/earth-token.svg`,
  Fire: `${TOKEN_ASSET_BASE}/fire-token.svg`,
  Air: `${TOKEN_ASSET_BASE}/air-token.svg`,
};

export default function ElementIcon({ element, size = 16, muted = false, className = '' }) {
  const src = TOKEN_BY_ELEMENT[element];
  if (!src) return null;
  const sz = typeof size === 'number' ? `${size / 16}cqw` : size;
  return (
    <img
      src={src}
      alt={t(element)}
      draggable={false}
      className={`shrink-0 ${className}`.trim()}
      style={{
        width: sz,
        height: sz,
        opacity: muted ? 0.25 : 1,
        filter: muted ? 'grayscale(1)' : 'drop-shadow(0 1px 2px rgba(0,0,0,0.5))',
      }}
    />
  );
}
